import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Button';
import DSIcon from '../../../base/DSIcon';

import styles from './CollapsibleText.module.scss';

const CollapsibleText = ({
  children,
  showMoreText,
  showLessText,
  isCollapsed: isCollapsedProp = true,
  showIcon = true,
  showButton = true,
  collapseCompletely = false,
  collapsedClassName = '',
  collapsibleHeight = 2
}) => {
  const [isCollapsed, setIsCollapsed] = useState(isCollapsedProp);

  const contentClassName = classNames(styles['collapsible-text__content'], {
    [styles['collapsible-text__content--collapsed']]: isCollapsed,
    [styles['collapsible-text__content--expanded']]: !isCollapsed,
    [styles['collapsible-text__content--collapse-completely']]:
      collapseCompletely,
    [collapsedClassName]: isCollapsed
  });

  const handleToggleCollapse = () => {
    setIsCollapsed(collapsed => !collapsed);
  };

  const buttonLocoKey = isCollapsed ? showMoreText : showLessText;
  const iconName = isCollapsed ? 'arrow_full_bottom' : 'arrow_full_top';

  return (
    <div
      className="collapsible-text"
      style={{ '--sah-collapsible-height': collapsibleHeight }}
    >
      <div className={contentClassName}>{children}</div>
      {showButton && (
        <Button
          color="link"
          onClick={handleToggleCollapse}
          renderTrailingIcon={() =>
            showIcon ? <DSIcon name={iconName} /> : null
          }
          renderContent={() => buttonLocoKey}
        />
      )}
    </div>
  );
};

CollapsibleText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  showMoreText: PropTypes.string.isRequired,
  showLessText: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool,
  showIcon: PropTypes.bool,
  showButton: PropTypes.bool,
  collapseCompletely: PropTypes.bool,
  collapsedClassName: PropTypes.string,
  collapsibleHeight: PropTypes.number
};

export default CollapsibleText;
